<nav #navbar
     class="navbar active">
  @if (isChangingCenter) {
    <div class="header-center-alert" role="status" aria-live="polite">
      <div class="header-center-alert__spinner" aria-hidden="true"></div>
      <span>{{ 'userProfileMenu.changingCenter' | translate }}</span>
    </div>
  }
  <div class="container-fluid">
    <div class="navbar-header">
      <button mat-icon-button
              class="mobile-header-action mobile-header-action--left"
              (click)="mobileMenuSidebarOpen($event,'overlay-open')"
              aria-label="Open sidebar">
        <i class="material-icons-outlined icon-color">menu</i>
      </button>
      <a href="#"
         onClick="return false;"
         class="navbar-toggle collapsed"
         (click)="isNavbarCollapsed = !isNavbarCollapsed"
         aria-expanded="false"></a>
      <a href="#"
         onClick="return false;"
         class="bars"
         (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
      <a class="navbar-brand"
         routerLink={{homePage}}>
        <img [src]="companyLogo"
             [alt]="companyName"
             class="sidebar-brand-panel__logo" />
      </a>
      <button mat-icon-button
              class="mobile-header-action mobile-header-action--right"
              (click)="toggleMobileNavbar()"
              [attr.aria-expanded]="!isNavbarCollapsed"
              aria-label="Open quick menu">
        <i class="material-icons-outlined icon-color">
          {{ isNavbarCollapsed ? 'swap_vert' : 'close' }}
        </i>
      </button>
    </div>
    <div class="collapse navbar-collapse"
         [ngClass]="isNavbarCollapsed ? '' : 'show'">
      <ul class="float-start collapse-menu-icon">
        <li>
          <button mat-icon-button
                  (click)="callSidemenuCollapse()"
                  class="sidemenu-collapse nav-notification-icons"> <i class="material-icons-outlined icon-color">
              menu
            </i></button>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        @if (webPunchEnabled) {
          <li class="web-punch-nav-item" *appCanAccess="webPunchAccess">
            <button mat-flat-button type="button" class="web-punch-nav-button" (click)="openWebPunch()">
              <mat-icon>schedule</mat-icon><span>{{ 'webPunch.quick.button' | translate }}</span>
            </button>
          </li>
        }
        <!-- Full Screen Button -->
        <li class="fullscreen">
          <button mat-icon-button
                  class="nav-notification-icons"
                  (click)="callFullscreen()"> <i class="material-icons-outlined icon-color">
              fullscreen
            </i></button>
        </li>
        <!-- #END# Full Screen Button -->
        <!-- #START# User Notifications -->
        <li>
          <app-notification-list [notifications]="userNotifications"
                                 [titleText]="'notifications.title'"
                                 [markAllLabel]="'notifications.markAllRead'"
                                 [footerLabel]="'notifications.readAll'"
                                 [emptyLabel]="'notifications.empty'"
                                 [triggerIcon]="'notifications_active'"
                                 [showClose]="true"
                                 (markAllAsRead)="onMarkAllUserNotificationsRead()"
                                 (readAll)="onReadAllUserNotifications()"
                                 (closeNotification)="onRemoveUserNotification($event)"
                                 (actionClick)="onUserNotificationActionClick($event)">
          </app-notification-list>
        </li>
        <!-- #END# User Notifications -->
        <!-- #START# System Updates -->
        <li>
          <app-notification-list [notifications]="systemUpdateNotifications"
                                 [titleText]="'systemUpdatesCatalog.title'"
                                 [markAllLabel]="'systemUpdatesCatalog.header.markAllRead'"
                                 [footerLabel]="'systemUpdatesCatalog.header.viewAll'"
                                  [emptyLabel]="'systemUpdatesCatalog.header.empty'"
                                 [triggerIcon]="'campaign'"
                                 [showClose]="false"
                                 (markAllAsRead)="onMarkAllSystemUpdatesRead()"
                                 (readAll)="onReadAllSystemUpdates()"
                                 (closeNotification)="onRemoveSystemUpdateNotification($event)"
                                 (notificationRead)="onSystemUpdateNotificationRead($event)"
                                 (actionClick)="onSystemUpdateNotificationActionClick($event)">
          </app-notification-list>
        </li>
        <!-- #END# System Updates -->
        <!-- #START# Multi Language-->
        <li class="nav-item lang-switcher">
          <app-language-list [flagvalue]="flagvalue"
                             [defaultFlag]="defaultFlag"
                             [listLang]="listLang"
                             [langStoreValue]="langStoreValue"
                             (languageSelected)="onLanguageChange($event)">
          </app-language-list>
        </li>
        <!-- #END# Multi Language-->
        <li class="nav-item user_profile"
            *appCanAccess="userProfileAccess">
          <app-user-profile-menu [userName]="userName || ''"
                                 [userImg]="userImg || ''"
                                 [showCentersEntry]="shouldShowCentersEntry"
                                 [currentCenter]="currentCenter"
                                 [currentCenterName]="currentCenterName"
                                 [availableCenters]="availableCenters"
                                 (accountClicked)="onAccountClicked()"
                                 (usersSettingsClicked)="usersSettingsClicked()"
                                 (systemUpdatesSettingsClicked)="onSystemUpdatesClick()"
                                 (inboxClicked)="onInboxClicked()"
                                 (centerSelected)="onCenterSelected($event)"
                                 (moduleSettingsClicked)="onModulosClick()"
                                 (centersSettingsClicked)="onCentersClick()"
                                 (rolesSettingsClicked)="onRolesClick()"
                                 (createPermissAccessClicked)="onCreatePermissAccessClicked()"
                                 (notificationsSettingsClicked)="onNotificationsSettingsClicked()"
                                 (logoutClicked)="logout()">
          </app-user-profile-menu>
        </li>
      </ul>

      <div class="mobile-navbar-panel"
           [class.mobile-navbar-panel--open]="!isNavbarCollapsed">
        <div class="mobile-navbar-panel__toolbar">
          <div class="mobile-navbar-panel__quick-actions">
            @if (webPunchEnabled) {
              <button mat-icon-button
                      type="button"
                      class="mobile-navbar-panel__icon mobile-navbar-panel__icon--punch"
                      *appCanAccess="webPunchAccess"
                      (click)="openWebPunch()"
                      [attr.aria-label]="'webPunch.quick.button' | translate">
                <mat-icon>schedule</mat-icon>
              </button>
            }
            <button mat-icon-button
                    type="button"
                    class="mobile-navbar-panel__icon"
                    (click)="callFullscreen()"
                    aria-label="Toggle fullscreen">
              <i class="material-icons-outlined">fullscreen</i>
            </button>

            <button mat-icon-button
                    type="button"
                    class="mobile-navbar-panel__icon mobile-navbar-panel__icon--notifications"
                    (click)="toggleMobileNotifications()"
                    [attr.aria-expanded]="isMobileNotificationsOpen"
                    aria-label="Toggle notifications">
              <i class="material-icons-outlined">notifications_none</i>
              @if (unreadUserNotificationsCount > 0) {
                <span class="mobile-navbar-panel__badge">{{ unreadUserNotificationsCount }}</span>
              }
            </button>

            <button mat-icon-button
                    type="button"
                    class="mobile-navbar-panel__icon mobile-navbar-panel__icon--notifications"
                    (click)="toggleMobileSystemUpdates()"
                    [attr.aria-expanded]="isMobileSystemUpdatesOpen"
                    aria-label="Toggle system updates">
              <i class="material-icons-outlined">campaign</i>
              @if (unreadSystemUpdateNotificationsCount > 0) {
                <span class="mobile-navbar-panel__badge">{{ unreadSystemUpdateNotificationsCount }}</span>
              }
            </button>

            <button mat-icon-button
                    type="button"
                    class="mobile-navbar-panel__icon mobile-navbar-panel__icon--flag"
                    (click)="toggleMobileLanguage()"
                    [attr.aria-expanded]="isMobileLanguageOpen"
                    aria-label="Toggle language selector">
              <img [src]="flagvalue || defaultFlag"
                   class="mobile-navbar-panel__flag"
                   alt="">
            </button>
          </div>

          <button mat-button
                  type="button"
                  class="mobile-navbar-panel__profile"
                  *appCanAccess="userProfileAccess"
                  (click)="toggleMobileSettings()"
                  [attr.aria-expanded]="isMobileSettingsOpen">
            <span class="mobile-navbar-panel__name">{{ userName || ('profileCatalog.defaultUser' | translate) }}</span>
            @if (userImg) {
              <img [src]="userImg"
                   class="mobile-navbar-panel__avatar"
                   alt="User">
            } @else {
              <span class="mobile-navbar-panel__avatar mobile-navbar-panel__avatar--fallback">
                {{ userInitials }}
              </span>
            }
          </button>
        </div>

        @if (isMobileNotificationsOpen) {
          <div class="mobile-navbar-panel__section">
            <button mat-menu-item
                    type="button"
                    (click)="onMarkAllUserNotificationsRead()">
              <i class="material-icons-outlined">done_all</i>
              <span>{{ 'notifications.markAllRead' | translate }}</span>
            </button>
            @for (notification of userNotifications; track notification.id || notification.title || notification.message) {
              <div class="mobile-navbar-panel__notification">
                @if (notification.title) {
                  <div class="mobile-navbar-panel__notification-message"><strong>{{ notification.title }}</strong></div>
                }
                <div class="mobile-navbar-panel__notification-message">{{ notification.message }}</div>
                <div class="mobile-navbar-panel__notification-time">{{ notification.time }}</div>
              </div>
            }
          </div>
        }

        @if (isMobileSystemUpdatesOpen) {
          <div class="mobile-navbar-panel__section">
            <button mat-menu-item
                    type="button"
                    (click)="onMarkAllSystemUpdatesRead()">
              <i class="material-icons-outlined">done_all</i>
              <span>{{ 'systemUpdatesCatalog.header.markAllRead' | translate }}</span>
            </button>
            @for (notification of systemUpdateNotifications; track notification.id || notification.title || notification.message) {
              <div class="mobile-navbar-panel__notification">
                @if (notification.title) {
                  <div class="mobile-navbar-panel__notification-message"><strong>{{ notification.title }}</strong></div>
                }
                <div class="mobile-navbar-panel__notification-message">{{ notification.message }}</div>
                <div class="mobile-navbar-panel__notification-time">{{ notification.time }}</div>
              </div>
            }
          </div>
        }

        @if (isMobileLanguageOpen) {
          <div class="mobile-navbar-panel__section mobile-navbar-panel__section--languages">
            @for (item of listLang; track item.lang) {
              <button mat-menu-item
                      type="button"
                      class="mobile-navbar-panel__language-item"
                      (click)="onLanguageChange(item)">
                <img [src]="item.flag"
                     class="mobile-navbar-panel__language-flag"
                     alt="">
                <span style="padding-left: 10px;">{{ item.text }}</span>
              </button>
            }
          </div>
        }

        @if (isMobileSettingsOpen) {
          <div class="mobile-navbar-panel__section mobile-navbar-panel__section--profile">
            <button type="button"
                    class="mobile-navbar-panel__action"
                    *appCanAccess="accountAccess"
                    (click)="onAccountClicked()">
              <i class="material-icons-outlined mobile-navbar-panel__menu-icon">person_outline</i>
              <span class="mobile-navbar-panel__menu-label">{{ 'userProfileMenu.profile' | translate }}</span>
            </button>
            <button type="button"
                    class="mobile-navbar-panel__action"
                    *appCanAccess="inboxAccess"
                    (click)="onInboxClicked()">
              <i class="material-icons-outlined mobile-navbar-panel__menu-icon">mail_outline</i>
              <span class="mobile-navbar-panel__menu-label">{{ 'userProfileMenu.inbox' | translate }}</span>
            </button>
            @if (shouldShowCentersEntry) {
              <button type="button"
                      class="mobile-navbar-panel__action"
                      *appCanAccess="centersSettingsAccess"
                      (click)="toggleMobileCentersGroup()">
                <i class="material-icons-outlined mobile-navbar-panel__menu-icon">domain</i>
                <span class="mobile-navbar-panel__menu-label">{{ currentCenterName || currentCenter || ('userProfileMenu.centers' | translate) }}</span>
                <i class="material-icons-outlined mobile-navbar-panel__settings-toggle-icon">
                  {{ isMobileCentersGroupOpen ? 'remove' : 'add' }}
                </i>
              </button>
              @if (isMobileCentersGroupOpen) {
                <div class="mobile-navbar-panel__settings-group"
                     *appCanAccess="centersSettingsAccess">
                  @for (center of availableCenters; track center) {
                    <button
                            type="button"
                            class="mobile-navbar-panel__action mobile-navbar-panel__action--nested"
                            (click)="onCenterSelected(center.center)">
                      <i class="material-icons-outlined mobile-navbar-panel__menu-icon">place</i>
                      <span class="mobile-navbar-panel__menu-label">
                        {{ center.name }}
                        @if (center.center === currentCenter) {
                          <strong>•</strong>
                        }
                      </span>
                    </button>
                  }
                </div>
              }
            }
            <button
                    type="button"
                    class="mobile-navbar-panel__action mobile-navbar-panel__settings-toggle"
                    *appCanAccess="settingsAccess"
                    (click)="toggleMobileSettingsGroup()">
              <span class="mobile-navbar-panel__settings-toggle-left">
                <i class="material-icons-outlined mobile-navbar-panel__menu-icon">settings</i>
                <span class="mobile-navbar-panel__menu-label">{{ 'userProfileMenu.settings' | translate }}</span>
              </span>
              <i class="material-icons-outlined mobile-navbar-panel__settings-toggle-icon">
                {{ isMobileSettingsGroupOpen ? 'remove' : 'add' }}
              </i>
            </button>
            @if (isMobileSettingsGroupOpen) {
              <div class="mobile-navbar-panel__settings-group"
                   *appCanAccess="settingsAccess">
                <button
                        type="button"
                        class="mobile-navbar-panel__action mobile-navbar-panel__action--nested"
                        *appCanAccess="centersSettingsAccess"
                        (click)="onCentersClick()">
                  <i class="material-icons-outlined mobile-navbar-panel__menu-icon">domain</i>
                  <span class="mobile-navbar-panel__menu-label">{{ 'userProfileMenu.centers' | translate }}</span>
                </button>
                <button
                        type="button"
                        class="mobile-navbar-panel__action mobile-navbar-panel__action--nested"
                        *appCanAccess="userAccess"
                        (click)="usersSettingsClicked()">
                  <i class="material-icons-outlined mobile-navbar-panel__menu-icon">groups</i>
                  <span class="mobile-navbar-panel__menu-label">{{ 'userProfileMenu.users' | translate }}</span>
                </button>
                <button
                        type="button"
                        class="mobile-navbar-panel__action mobile-navbar-panel__action--nested"
                        *appCanAccess="systemUpdatesAccess"
                        (click)="onSystemUpdatesClick()">
                  <i class="material-icons-outlined mobile-navbar-panel__menu-icon">system_update_alt</i>
                  <span class="mobile-navbar-panel__menu-label">{{ 'userProfileMenu.systemUpdates' | translate }}</span>
                </button>
                <button
                        type="button"
                        class="mobile-navbar-panel__action mobile-navbar-panel__action--nested"
                        *appCanAccess="rolesSettingsAccess"
                        (click)="onRolesClick()">
                  <i class="material-icons-outlined mobile-navbar-panel__menu-icon">shield</i>
                  <span class="mobile-navbar-panel__menu-label">{{ 'userProfileMenu.roles' | translate }}</span>
                </button>
                <button
                        type="button"
                        class="mobile-navbar-panel__action mobile-navbar-panel__action--nested"
                        *appCanAccess="createPermissAccess"
                        (click)="onCreatePermissAccessClicked()">
                  <i class="material-icons-outlined mobile-navbar-panel__menu-icon">vpn_key</i>
                  <span class="mobile-navbar-panel__menu-label">{{ 'userProfileMenu.permissions' | translate }}</span>
                </button>
                <button
                        type="button"
                        class="mobile-navbar-panel__action mobile-navbar-panel__action--nested"
                        *appCanAccess="modulosSettingsAccess"
                        (click)="onModulosClick()">
                  <i class="material-icons-outlined mobile-navbar-panel__menu-icon">grid_view</i>
                  <span class="mobile-navbar-panel__menu-label">{{ 'userProfileMenu.modules' | translate }}</span>
                </button>
              </div>
            }
            <button
                    type="button"
                    class="mobile-navbar-panel__action"
                    *appCanAccess="userProfileAccess"
                    (click)="logout()">
              <i class="material-icons-outlined mobile-navbar-panel__menu-icon">logout</i>
              <span class="mobile-navbar-panel__menu-label">{{ 'userProfileMenu.logout' | translate }}</span>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</nav>
